import styled from 'styled-components';

const EntryAnchorStyled = styled.a`
  align-items: center;
  color: unset;
  display: flex;
  text-decoration: none;

  :hover {
    color: unset;
  }

  :visited {
    color: unset;
  }

  :active {
    color: unset;
  }
`;

const EntryButtonStyled = styled.a`
  text-decoration: none;
`;

const IframeContainerStyled = styled.div`
  height: 100%;

  .iframe-height {
    height: 100%;
  }
`;

export { EntryAnchorStyled, EntryButtonStyled, IframeContainerStyled };
